<template>
	<article>
		<div>
			<span class="xbed-sub-title">值班账单列表</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>值班账单列表</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
		<Form @submit.native.prevent="preventSubmit" inline>
			<FormItem label='创建时间：' :label-width='100'>
				<DatePicker type='daterange' v-model="creatTime" placeholder="请选择使时间" :clearable='false' class="date-time" style="width: 230px"></DatePicker>
			</FormItem>
			<FormItem label='结算时间：' :label-width='100'>
				<DatePicker type='daterange' v-model="settleTime" placeholder="请选择使时间" class="date-time" style="width: 230px"></DatePicker>
			</FormItem>
			<FormItem label='状态：' :label-width='100'>
				<Select v-model="queryDutyList.status" filterable>
					<Option value="S00">全部</Option>
					<Option value="S01">未结</Option>
					<Option value="S02">完成</Option>
					<Option value="S03">已取消</Option>
				</Select>
			</FormItem>
			<FormItem>
				<Button type='primary' @click='keyWordsQuery'>查询</Button>
			</FormItem>
			<FormItem>
				<Button type='primary' @click="exportTable" :loading="exportBtn">导出账单</Button>
			</FormItem>
		</Form>
		<Content>
			<Table stripe :columns="dutyColumns" :data="dutySheetList" :loading='dutyBillLoading'></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement='top' :current='queryDutyList.page' :page-size='queryDutyList.size' :total='listTotal' @on-change='changePage' @on-page-size-change='changePageSize'></Page>
			</div>
		</Content>
	</article>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";
export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	data() {
		return {
			exportBtn: false,
			dutyBillLoading: false,
			creatTime: [
				Moment().subtract( 14, 'day' ).format( "YYYY-MM-DD" ),
				Moment().format( 'YYYY-MM-DD' )
			],
			settleTime: [],
			listTotal: 0,
			dutySheetList: [],
			queryDutyList: {
				createDateEnd: '',
				createDateStart: '',
				settlementDateEnd: '',
				settlementDateStart: '',
				page: 1,
				size: 10,
				status: 'S00'
			},
			query: {
				createDateEnd: '',
				createDateStart: '',
				settlementDateEnd: '',
				settlementDateStart: '',
				page: 1,
				size: 10,
				status: 'S00'
			},
			dutyColumns: [
				{
					title: '值班单号',
					key: 'dutyOrderNo',
					align: 'center',
					width: 260
				},
				{
					title: '创建时间',
					key: 'createDate',
					align: 'center',
					width: 130,
					render: ( h, params ) => {
						const createDate = params.row.createDate ? Moment( params.row.createDate ).format( "YYYY-MM-DD HH:mm:ss" ) : '';
						return h( 'div', {}, createDate )
					}
				},
				{
					title: '结算时间',
					key: 'settlementDate',
					align: 'center',
					width: 130,
					render: ( h, params ) => {
						const settlementDate = params.row.settlementDate ? Moment( params.row.settlementDate ).format( "YYYY-MM-DD HH:mm:ss" ) : '';
						return h( 'div', {}, settlementDate )
					}
				},
				{
					title: '下单人',
					key: 'orderCreateName',
					align: 'center',
					width: 100
				},
				{
					title: '值班时间',
					key: 'dutyStartDate',
					align: 'center',
					width: 130,
					render: ( h, params ) => {
						const start = params.row.dutyStartDate ? Moment( params.row.dutyStartDate ).format( "YYYY-MM-DD HH:mm:ss" ) : '';
						const end = params.row.dutyEndDate ? Moment( params.row.dutyEndDate ).format( "YYYY-MM-DD HH:mm:ss" ) : '';
						return ( h, [
							h( 'p', {}, start ),
							h( 'p', {}, end ),
						] )
					}
				},
				{
					title: '值班地点',
					key: 'buildingAddress',
					align: 'center',
					width: 200
				},
				{
					title: '付款方',
					key: 'payerType',
					align: 'center',
					width: 100
				},
				{
					title: '付款人',
					key: 'payer',
					align: 'center',
					width: 100
				},
				{
					title: '状态',
					key: 'status',
					align: 'center',
					width: 100,
					render: ( h, params ) => {
						let checkType = '';
						switch ( params.row.status ) {
							case 'S01':
								checkType = '未结';
								break;
							case 'S02':
								checkType = '完成';
								break;
							case 'S03':
								checkType = '已取消';
								break;
						}
						return h( 'div', {}, checkType );
					}
				},
				{
					title: '管家姓名',
					key: 'cleanerName',
					align: 'center',
					width: 100
				},
				{
					title: '管家号码',
					key: 'cleanerMobile',
					align: 'center',
					width: 150
				},
				{
					title: '管家薪酬',
					key: 'housekeeperMoney',
					align: 'center',
					width: 100,
					render: ( h, params ) => {
						const housekeeperMoney = params.row.housekeeperMoney ? ( params.row.housekeeperMoney / 100 ).toFixed( 2 ) : '0';
						return h( 'div', {}, housekeeperMoney )
					}
				},
				{
					title: '值班基本薪酬',
					key: 'dutyOrderMoney',
					align: 'center',
					width: 130,
					render: ( h, params ) => {
						const dutyOrderMoney = params.row.dutyOrderMoney ? ( params.row.dutyOrderMoney / 100 ).toFixed( 2 ) : '0';
						return h( 'div', {}, dutyOrderMoney )
					}
				},
				{
					title: '值班平台扣罚',
					key: 'punishMoney',
					align: 'center',
					width: 130,
					render: ( h, params ) => {
						const punishMoney = params.row.punishMoney ? ( params.row.punishMoney / 100 ).toFixed( 2 ) : '0';
						return h( 'div', {}, punishMoney )
					}
				},
				{
					title: '保险费',
					key: 'insuranceMoney',
					align: 'center',
					width: 100,
					render: ( h, params ) => {
						const insuranceMoney = params.row.insuranceMoney ? ( params.row.insuranceMoney / 100 ).toFixed( 2 ) : '0';
						return h( 'div', {}, insuranceMoney )
					}
				},
			],
		}
	},
	mounted() {
		this.$Notice.config( {
			top: 200
		} );
		this.queryDutyData();
	},
	methods: {
		async queryDutyData() {
			this.query.createDateStart = this.creatTime[0] ? Moment( this.creatTime[0] ).format( 'YYYY-MM-DD HH:mm:ss' ) : "";
			this.query.createDateEnd = this.creatTime[1] ? Moment( this.creatTime[1] ).format( 'YYYY-MM-DD 23:59:59' ) : "";

			this.query.settlementDateStart = this.settleTime[0] ? Moment( this.settleTime[0] ).format( 'YYYY-MM-DD HH:mm:ss' ) : "";
			this.query.settlementDateEnd = this.settleTime[1] ? Moment( this.settleTime[1] ).format( 'YYYY-MM-DD 23:59:59' ) : "";

			this.query.status = this.queryDutyList.status == 'S00' ? '' : this.queryDutyList.status;
			// 加载loading
			this.dutyBillLoading = true;
			const resp = ( await API.omsAPI[this.env].cleaner.queryXbcleanXbDutyBillList( this.query, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取列表失败",
					desc: resp.msg
				} );
				return
			}
			this.dutySheetList = resp.content;
			this.listTotal = resp.totalCount;
			this.dutyBillLoading = false;
		},
		changePage( page ) {
			this.query.page = page;
			this.queryDutyData();
		},
		changePageSize( pageSize ) {
			this.query.page = 1;
			this.query.size = pageSize;
			this.queryDutyData();
		},
		keyWordsQuery() {
			this.query = Object.assign( {}, this.queryDutyList );
			this.queryDutyData();
		},
		// 导出列表
		exportTable() {
			let params = {
				createDateEnd: this.query.createDateEnd ? this.query.createDateEnd : '',
				createDateStart: this.query.createDateStart ? this.query.createDateStart : '',
				settlementDateStart: this.query.settlementDateStart ? this.query.settlementDateStart : '',
				settlementDateEnd: this.query.settlementDateEnd ? this.query.settlementDateEnd : '',
				page: 1,
				size: 999999,
				status: this.query.status == 'S00' ? '' : this.query.status
			}
			const initParams = params => {
				let paramStr = '';
				Object.keys( params ).forEach( item => {
					if ( params[item] !== '' ) {
						paramStr += item + '=' + params[item] + '&';
					}
				} )
				return paramStr.substring( 0, paramStr.lastIndexOf( '&' ) );
			}
			let paramsInfos = initParams( params );
			let url = `${ Config[this.env].analysisUrl }excel/exportDutyBillList?${ paramsInfos }`;
			// window.open(url, "_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )
		}
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/cleaner/dutyBill-list.vue